import { useEffect, useState } from 'react';

function diff(target) {
  const t = new Date(target).getTime() - Date.now();
  if (isNaN(t) || t <= 0) return null;
  return {
    d: Math.floor(t / 86400000),
    h: Math.floor((t % 86400000) / 3600000),
    m: Math.floor((t % 3600000) / 60000),
    s: Math.floor((t % 60000) / 1000),
  };
}

export function Countdown({ target, testid = 'auction-countdown' }) {
  const [c, setC] = useState(() => diff(target));
  useEffect(() => {
    const id = setInterval(() => setC(diff(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!c) return <span data-testid={testid} className="font-heading font-bold text-sm text-[#EE5A01]">Auction in progress / closed</span>;
  const cell = (v, l) => (
    <div className="flex flex-col items-center">
      <span className="font-heading font-black text-2xl sm:text-4xl tabular-nums text-white bg-black/30 rounded-lg px-3 py-2 min-w-[3.2rem] text-center">{String(v).padStart(2, '0')}</span>
      <span className="mt-2 font-body text-[10px] uppercase tracking-[0.18em] text-white/60">{l}</span>
    </div>
  );
  return (
    <div data-testid={testid} className="flex items-center gap-3 sm:gap-4">
      {cell(c.d, 'Days')}{cell(c.h, 'Hrs')}{cell(c.m, 'Min')}{cell(c.s, 'Sec')}
    </div>
  );
}
